import { RootState } from "store/store";
import { connect } from "react-redux";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import { getErrorResponseMessage } from "store/common/initialization/initialization-selectors";
import GuestTenantsEnroll from "./GuestTenantsEnroll";
import { fetchEnvironments } from "store/environments/environment-thunks";
import {
    fetchEnrollCache,
    fetchEnrollWorkflow,
} from "store/environments/tenants/enroll-tenant/enroll-tenant-thunks";
import { setActiveStepData } from "store/environments/tenants/enroll-tenant/enroll-tenant-actions";
import { getActiveTenantDeleteWorkflow } from "store/environments/tenants/tenant-delete/tenant-delete-selectors";
import { fetchTenants } from "store/environments/tenants/tenants-thunks";
import { getActiveTenantMoniker } from "store/environments/tenants/tenants-selectors";
import { flowRight } from "lodash";
import withScroll from "hocs/withScroll/withScroll";

const mapStateToProps = (state: RootState) => ({
    envMoniker: getActiveEnvironmentMoniker(state),
    errorMessage: getErrorResponseMessage(state),
    activeTenantDeleteWorkflow: getActiveTenantDeleteWorkflow(state),
    tenantMoniker: getActiveTenantMoniker(state),
});
const Container = connect(mapStateToProps, {
    fetchEnvironments,
    fetchEnrollCache,
    fetchEnrollWorkflow,
    setActiveStepData,
    fetchTenants,
})(GuestTenantsEnroll);

const GuestTenantsEnrollContainer = flowRight(withScroll)(Container);

export default GuestTenantsEnrollContainer;
